import React, { FC } from "react";

import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { GuideStatus } from "@mapmycustomers/shared";
import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";

import AvatarGroup from "@app/component/AvatarGroup";

import styles from "./GuideAssignees.module.scss";

const messages = defineMessages({
  noAssignees: {
    id: "onboarding.guides.card.assignees.none",
    defaultMessage: "Not assigned yet",
    description: "Label to show when Guide has no assignees",
  },
  progress: {
    id: "onboarding.guides.card.assignees.progress",
    defaultMessage: "{progress, number, ::percent} Complete {icon}",
    description: "Label to show when Guide has assignees",
  },
});

export interface GuideAssigneesProps {
  guideStatus?: GuideUserStatus[];
  onClick?: () => void;
}

const GuideAssignees: FC<GuideAssigneesProps> = ({ guideStatus, onClick }) => {
  const intl = useIntl();

  const completion: number = guideStatus?.length
    ? guideStatus.filter(({ status }) => status === GuideStatus.COMPLETED).length /
      guideStatus.length
    : 0;

  return (
    <div className={styles.container}>
      <AvatarGroup size="small" users={(guideStatus ?? []).map(({ user }) => user)} />
      <div
        className={cn(styles.progress, {
          [styles.done]: guideStatus?.length && completion >= 1,
          [styles.none]: !guideStatus?.length,
        })}
        onClick={guideStatus?.length ? onClick : undefined}
      >
        {guideStatus?.length
          ? intl.formatMessage(messages.progress, {
              icon: <FontAwesomeIcon icon={faChevronRight} />,
              progress: completion,
            })
          : intl.formatMessage(messages.noAssignees)}
      </div>
    </div>
  );
};

export default GuideAssignees;
